import { wsService } from "./wsService";

function login(username, password) {
  const param = {
    username: username,
    password: password,
  };
  return wsService.make_post_request("auth/login", param);
}

function isAuthenticated() {
  /*
  console.log("Checking if authenticated", localStorage.getItem("token") != undefined && localStorage.getItem("expire_in") != undefined && Math.floor(Date.now() / 1000) < localStorage.getItem("expire_in"),localStorage.getItem("expire_in"));
  console.log("Token exists:", localStorage.getItem("token") != undefined);
  console.log("Expire_in exists:", localStorage.getItem("expire_in") != undefined);
  console.log("Token is not expired:", localStorage.getItem("expire_in") !== null ? localStorage.getItem("expire_in") : "null");
  */

  const expire_in = localStorage.getItem("expire_in") !== null ? localStorage.getItem("expire_in") : "null"
  
  return (
    localStorage.getItem("token") != undefined && 
    localStorage.getItem("expire_in") != undefined && 
    (
      expire_in == "null" ||
      Math.floor(Date.now() / 1000) < expire_in
    )
  );
}

function logOut() {
  localStorage.clear();
}

export const authService = {
  login,
  isAuthenticated,
  logOut,
};
